/** * @file TableTr */

<template>
  <tr class="js_error">
    <slot />
  </tr>
</template>

<script>
export default {}
</script>

<style></style>
